module.exports = __webpack_public_path__ + "static/media/  (41).1474b860.jpg";